import { render, staticRenderFns } from "./LeadSuperActions.vue?vue&type=template&id=a98b42ae&scoped=true"
import script from "./LeadSuperActions.vue?vue&type=script&lang=ts"
export * from "./LeadSuperActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98b42ae",
  null
  
)

export default component.exports